export const environment = {
    apiUrl: "https://admin.focusedon-dev.ai/apigateway/",
    // Firebase
    firebaseConfig: {
        apiKey: "AIzaSyAA2tiyQ6uSdUzKCCocJG2RIBgrvW78XKg",
        authDomain: "admin-mdsw-dev.firebaseapp.com",
        projectId: "admin-mdsw-dev",
        storageBucket: "admin-mdsw-dev.firebasestorage.app",
        messagingSenderId: "609893034803",
        appId: "1:609893034803:web:dfab46ca9a3ce020812c46"
    },
};